module.exports = __webpack_public_path__ + "static/media/ER.ae08238c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/ER.svg
// module id = 2147
// module chunks = 7